import {
    DEFAULT_DESCRIPTION,
    OG_DEFAULT_DESCRIPTION,
    OG_DEFAULT_IMAGE
} from "../../../pages/config/settings";
import {truncateTree} from "../../../utility/componentUtil";
import {generateNextImageUrl} from "../../../utility/navigationUtil";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";

const MAX_DESCRIPTION_LENGTH = 150;
const OG_IMAGE_SETTINGS = {
    ratio: 'portrait_ratio3x4',
    width: 780
}

const truncateDescription = (description: string | RichTextElement, maxLength: number) => {
    if (typeof description === 'object') {
        return truncateTree(description, maxLength);

    } else if (typeof description === 'string') {
        return description.length > maxLength ? description.substring(0, maxLength) + "..." :
            description;
    }
}

const generateOgImageUrl = (url: string) => generateNextImageUrl("/media" + url,
                                                                 OG_IMAGE_SETTINGS.ratio,
                                                                 OG_IMAGE_SETTINGS.width);

const getOgInfoFromContent = (content: any, type: 'ogdescription' | 'ogtitle' | 'ogimage') => {
    const contentSettings = content?.settings ||
                            content?.publicationSettings ||
                            content?.eventSettings ||
                            content?.newsSettings;
    return contentSettings?.[type] || null;
}

export const getTitle = (document: any) => {
    const htmlTitle = document.htmlTitle;
    const title = document.title;
    return htmlTitle || title;
}

export const getDescription = (document: any, globalSettings: any) => {
    const htmlDescription = document.htmlDescription;
    const teaserText = document.teaserText?.textAsTree;
    const descriptionText = htmlDescription || teaserText || globalSettings[DEFAULT_DESCRIPTION];
    return truncateDescription(descriptionText, MAX_DESCRIPTION_LENGTH);
}

export const getOgTitle = (page: any, specialContent: any, isPagelikeContent: boolean) => {
    if (isPagelikeContent) {
        const contentOgTitle = getOgInfoFromContent(specialContent, 'ogtitle');
        const contentTitle = specialContent?.title;
        return contentOgTitle || contentTitle;
    } else {
        const pageOgTitle = page.settings?.ogtitle;
        const pageTitle = page.title;
        return pageOgTitle || pageTitle;
    }
}

export const getOgDescription = (page: any, specialContent: any, globalSettings: any,
                                 isPagelikeContent: boolean) => {
    let ogDescriptionText = '';
    if (isPagelikeContent) {
        const contentOgDescription = getOgInfoFromContent(specialContent, 'ogdescription');
        const contentTeaserText = specialContent?.teaserText?.textAsTree;
        ogDescriptionText =
            contentOgDescription || contentTeaserText || globalSettings[OG_DEFAULT_DESCRIPTION];
    } else {
        const pageOgDescription = page.settings?.ogdescription;
        const pageTeaserText = page.teaserText?.textAsTree;
        ogDescriptionText =
            pageOgDescription || pageTeaserText || globalSettings[OG_DEFAULT_DESCRIPTION];
    }
    return truncateDescription(ogDescriptionText, MAX_DESCRIPTION_LENGTH);
}


export const getOgImage = (page: any, specialContent: any, globalSettings: any,
                           isPagelikeContent: boolean) => {
    if (!specialContent) {
        if (page.settings?.ogimage) {
            return generateOgImageUrl(page.settings?.ogimage);
        } else if (page.picture?.data?.uri) {
            return generateOgImageUrl(page.picture.data.uri)
        }
    }
    if (isPagelikeContent) {
        const contentOgImage = getOgInfoFromContent(specialContent, 'ogimage');
        if (contentOgImage) {
            return generateOgImageUrl(contentOgImage)
        } else if (specialContent.picture?.data?.uri) {
            return generateOgImageUrl(specialContent.picture.data.uri)
        }
    }
    return generateOgImageUrl(globalSettings[OG_DEFAULT_IMAGE]);
}

export const getRobotsContent = (document: any) => document.robots ? "noindex, nofollow" :
    "index, follow";

export const getCanonicalUrl = (document: any, currentUrl: string) => {
    try {
        const canonicalUrl = document.canonicalLink?.[0]?.canonicalUrl || document.canonicalUrl;
        const canonicalDomain = new URL(canonicalUrl).hostname;
        const currentDomain = currentUrl && new URL(currentUrl).hostname;
        if (canonicalDomain === currentDomain) {
            return canonicalUrl;
        }
        return canonicalUrl.replace(canonicalDomain, currentDomain);
    } catch (e) {
        return currentUrl;
    }
}